import { render } from "./ContactMe.vue?vue&type=template&id=664ced52&scoped=true"
import script from "./ContactMe.vue?vue&type=script&lang=js"
export * from "./ContactMe.vue?vue&type=script&lang=js"

import "./ContactMe.vue?vue&type=style&index=0&id=664ced52&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-664ced52"]])

export default __exports__